import { render } from "./ModalDetail.vue?vue&type=template&id=a09d4226"
import script from "./ModalDetail.vue?vue&type=script&lang=js"
export * from "./ModalDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__